const fonts = {
  titles: 'Montserrat',
  text: 'Space mono'
};
const palette = {
  colorPrimary: '#282A36', // Main Primary color */
  colorSecondaryFirst: '#FFD900', // Main Secondary color (1) */
  colorSecondarySecond: '#AA5239' // Main Secondary color (2) */
};

export default { fonts, palette };
